export const NameType = {
  CUSTOM: 'CUSTOM',
  FORM_STRENGTH: 'FORM_STRENGTH',
  AMOUNT_UNIT_PACKAGE: 'AMOUNT_UNIT_PACKAGE',
}
